import { cn } from "@/lib/utils"

export function shouldShowIncomingChatAvatar(opts: {
  isOwnMessage: boolean
  sameSenderNext: boolean
  sameDayNext: boolean
  nextIsStacked?: boolean
}): boolean {
  if (opts.isOwnMessage) return false
  if (opts.sameSenderNext && opts.sameDayNext && !opts.nextIsStacked) return false
  return true
}

export function chatBubbleTimestampClass(isOwnMessage: boolean): string {
  return isOwnMessage
    ? "mb-px shrink-0 text-[11px] leading-[15px] text-neutral-500/75"
    : "mb-px shrink-0 text-[11px] leading-[15px] text-white/55"
}

export function chatImageTimestampClass(): string {
  return "rounded-md bg-black/45 px-1.5 py-0.5 text-[11px] leading-[14px] text-neutral-50"
}

export function chatReplyQuoteWrapClass(isOwnMessage: boolean, opts?: { compact?: boolean; embedded?: boolean }): string {
  const { compact = false, embedded = false } = opts ?? {}
  return cn(
    "mb-2 space-y-0.5 rounded-md px-3 pt-2 pb-2",
    isOwnMessage ? "bg-neutral-100 ring-1 ring-black/[0.08]" : "bg-white/[0.1]",
    compact && "py-2.5",
    (compact || embedded) && "mb-0",
    embedded && "bg-transparent px-0 py-0 ring-0",
  )
}

export function chatReplyQuoteSenderClass(isOwnMessage: boolean): string {
  return cn(
    "truncate text-[11px] font-semibold leading-4",
    isOwnMessage ? "text-neutral-800" : "text-white/90",
  )
}

export function chatReplyQuoteSnippetClass(
  isOwnMessage: boolean,
  opts?: { embedded?: boolean; compact?: boolean },
): string {
  const { embedded = false, compact = false } = opts ?? {}
  if (embedded) {
    return cn(
      "line-clamp-1 text-sm leading-snug",
      isOwnMessage ? "text-neutral-600" : "text-white/80",
    )
  }
  return cn(
    "text-sm leading-snug",
    compact ? "line-clamp-1" : "line-clamp-2",
    isOwnMessage ? "text-neutral-600" : "text-white/85",
  )
}
